import React from 'react';
import { FaLaptopCode, FaCogs, FaServer, FaHandsHelping } from 'react-icons/fa';

export const services = [
  {
    icon: <FaLaptopCode />,
    title: 'WEB DEVELOPMENT',
    info:
      'When it comes to functional and responsive websites, I got you covered.',
  },
  {
    icon: <FaCogs />,
    title: 'WEB MAINTENANCE',
    info: 'In a position to doctor your website with the latest technologies.',
  },
  {
    icon: <FaServer />,
    title: 'BACKEND DEVELOPMENT',
    info: "I'm also specialized in back-end architecture of websites.",
  },
  {
    icon: <FaHandsHelping />,
    title: 'FREELANCER',
    info: 'I do freelancing, helping small businesses grow.',
  },
];
